/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ taken: NonNullable<unknown>, capacity: NonNullable<unknown> }} Requestsplacestaken2Inputs */

const en_requestsplacestaken2 = /** @type {(inputs: Requestsplacestaken2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.taken} of ${i?.capacity} places taken`)
};

const de_requestsplacestaken2 = /** @type {(inputs: Requestsplacestaken2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.taken} von ${i?.capacity} Plätzen vergeben`)
};

/**
* | output |
* | --- |
* | "{taken} of {capacity} places taken" |
*
* @param {Requestsplacestaken2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const requestsplacestaken2 = /** @type {((inputs: Requestsplacestaken2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requestsplacestaken2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requestsplacestaken2(inputs)
	return de_requestsplacestaken2(inputs)
});
export { requestsplacestaken2 as "requestsPlacesTaken" }